
import { defineComponent, computed, toRef, watch } from 'vue';

import WdwDynbox from '@/components/general/WdwDynbox.vue';

import { IAskusQuestion } from '@/models/askus.model';

import { domainStore } from '@/store/domain-store';
import { askusStore } from '@/store/askus-store';

import useConverter from '@/composables/general/useConverter';
import useStringManip from '@/composables/general/useStringManip';

export default defineComponent({
  name: 'QuestionForm',
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    WdwDynbox,
  },
  emits: ['openQuestion'],
  setup(props, context) {
    const text = toRef(props, 'text');
    const { truncateAfterWord } = useStringManip();
    const { formattedDate, toBool } = useConverter();

    const askus = computed(() => {
      return askusStore.getState().askus;
    });
    const suggestions = computed(() => {
      return askusStore.getState().suggestions;
    });

    function openQuestion(question: IAskusQuestion, questionid: number) {
      context.emit('openQuestion', question, questionid);
    }

    watch(text, (newVal, oldVal) => {
      if (newVal !== oldVal && newVal.length > 2) {
        askusStore.getSuggestions(askus.value.id, text.value);
      }
    });

    return {
      domainStore,
      askus,
      suggestions,
      truncateAfterWord,
      formattedDate,
      openQuestion,
    };
  },
});
